import {
  REJECT_PENDING_REQUEST_REQUEST,
  REJECT_PENDING_REQUEST_SUCCESS,
  REJECT_PENDING_REQUEST_FAILURE,
} from '../../../../Constants/actionTypes';

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const rejectPendingRequestReducer = (state = initialState, action) => {
  switch (action.type) {
    case REJECT_PENDING_REQUEST_REQUEST:
      return { ...state, loading: true, error: null };
    case REJECT_PENDING_REQUEST_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case REJECT_PENDING_REQUEST_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
};

export default rejectPendingRequestReducer;
